import React from 'react';
import { ui } from './ui';
import { EXAM_TYPES, CLASSES, SESSIONS, SUBJECT_PRESETS, blueprintTotal } from './aiPaperUtils';
import { Field, TextInput, SelectInput, SectionCard } from './BlueprintParts';
import StylePanel, { profileToBlueprint } from './StylePanel';

const LANGS = [
  { id: 'english', label: 'English' },
  { id: 'hindi', label: 'हिंदी (Hindi)' },
  { id: 'bilingual', label: 'Bilingual (Side-by-Side)' }
];

function BlueprintStep({ user, config, setConfig, blueprint, setBlueprint, totalPages, style, setStyle }) {
  const applyStyle = (p) => {
    setBlueprint(profileToBlueprint(p));
    setConfig((c) => ({
      ...c,
      maxMarks: p.maxMarks || c.maxMarks,
      duration: p.duration || c.duration,
      languageMode: p.language || c.languageMode
    }));
  };
  const set = (k) => (v) => setConfig((c) => ({ ...c, [k]: v }));
  const total = blueprintTotal(blueprint);
  const max = Number(config.maxMarks) || 0;

  const toggle = (name) => setBlueprint((bp) => bp.map((s) => (s.name === name ? { ...s, enabled: !s.enabled } : s)));
  const onRow = (name, i, key, v) => setBlueprint((bp) => bp.map((s) => (s.name !== name ? s
    : { ...s, rows: s.rows.map((r, j) => (j === i ? { ...r, [key]: v } : r)) })));
  const onExtra = (name, v) => setBlueprint((bp) => bp.map((s) => (s.name === name ? { ...s, extra: v } : s)));

  return (
    <div>
    {user && <StylePanel user={user} config={config} style={style} onStyle={setStyle} onApply={applyStyle} />}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(320px,1fr))', gap: 20 }}>
      <div>
        <Field label="Paper title (optional)"><TextInput value={config.title} onChange={set('title')} placeholder="e.g. Half-Yearly Exam — Science" /></Field>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <Field label="Exam type"><SelectInput value={config.examType} onChange={set('examType')} options={EXAM_TYPES} /></Field>
          <Field label="Session"><SelectInput value={config.session} onChange={set('session')} options={SESSIONS} /></Field>
          <Field label="Class"><SelectInput value={config.class} onChange={set('class')} options={CLASSES} /></Field>
          <Field label="Subject">
            <TextInput value={config.subject} onChange={set('subject')} list="aip-subjects" placeholder="Select or type" />
            <datalist id="aip-subjects">{SUBJECT_PRESETS.map((s) => <option key={s} value={s} />)}</datalist>
          </Field>
          <Field label="Duration"><TextInput value={config.duration} onChange={set('duration')} placeholder="3 Hours" /></Field>
          <Field label="Maximum marks"><TextInput type="number" value={config.maxMarks} onChange={set('maxMarks')} placeholder="80" /></Field>
        </div>
        <Field label="Language">
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {LANGS.map((l) => (
              <button key={l.id} type="button" onClick={() => set('languageMode')(l.id)}
                style={{ ...ui.btnGhost, background: config.languageMode === l.id ? '#4f46e5' : '#eef2ff', color: config.languageMode === l.id ? '#fff' : '#3730a3' }}>
                {l.label}
              </button>
            ))}
          </div>
        </Field>
        <Field label={`Limit to pages (optional, 1–${totalPages || '?'})`}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <TextInput type="number" value={config.pageFrom} onChange={set('pageFrom')} placeholder="from" />
            <span>to</span>
            <TextInput type="number" value={config.pageTo} onChange={set('pageTo')} placeholder="to" />
          </div>
        </Field>
      </div>
      <div>
        <label style={ui.label}>Question type distribution</label>
        {blueprint.map((s) => <SectionCard key={s.name} section={s} onToggle={toggle} onRow={onRow} onExtra={onExtra} />)}
        <div style={max && total !== max ? ui.warnBox : ui.okBox}>
          Blueprint total: <b>{total}</b> marks{max ? ` · Maximum marks: ${max}` : ''}
          {max && total !== max ? ` — differs by ${Math.abs(total - max)}. You can still generate and fix it in the editor.` : max ? ' ✓' : ''}
        </div>
      </div>
    </div>
    </div>
  );
}

export default BlueprintStep;
